import { getProductIcon } from 'legoland-sdk';
import styled from 'styled-components';
import { propStyling, tombac } from 'tombac';
import { jsx as _jsx } from "react/jsx-runtime";
const ContractProductsListContainer = styled.div.withConfig({
  displayName: "ContractProductsList__ContractProductsListContainer"
})(["display:flex;align-items:center;padding:", ";", ""], tombac.space(1, 3), propStyling);
const ContractProductContainer = styled.div.withConfig({
  displayName: "ContractProductsList__ContractProductContainer"
})(["filter:", ";margin-right:", ";opacity:", ";&:last-child{margin-right:0;}& > svg{display:block;}"], props => props.expired ? 'grayscale(100%)' : 'none', tombac.space(1), props => props.expired ? 0.5 : 1);
export const ContractProductsList = ({
  expired = false,
  products,
  ...stylingProps
}) => {
  return /*#__PURE__*/_jsx(ContractProductsListContainer, {
    ...stylingProps,
    "data-sentry-element": "ContractProductsListContainer",
    "data-sentry-component": "ContractProductsList",
    "data-sentry-source-file": "ContractProductsList.tsx",
    children: products.map(product => {
      const Icon = getProductIcon(product.id);
      return /*#__PURE__*/_jsx(ContractProductContainer, {
        expired: expired,
        children: /*#__PURE__*/_jsx(Icon, {
          height: "32",
          width: "32"
        })
      }, product.id);
    })
  });
};